[
  {
    "id": "TB-M8-001",
    "module": "Taalbegrip",
    "difficulty": 303,
    "question": "Lees de tekst:\n\n\"Uit onderzoek van de Universiteit Utrecht blijkt dat kinderen die dagelijks lezen, betere schoolresultaten halen. De onderzoekers volgden 5.000 leerlingen gedurende 3 jaar.\"\n\nIs deze tekst een feit of een mening?",
    "options": [
      "Een feit (gebaseerd op onderzoek met cijfers)",
      "Een mening (iemand vindt dit)",
      "Allebei",
      "Geen van beide"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kritisch_lezen",
    "subSkill": "feit_mening",
    "familyId": "TB-FEIT-ONDERZOEK",
    "explanation": "De tekst verwijst naar een specifiek onderzoek met meetbare gegevens (5.000 leerlingen, 3 jaar). Dat maakt het een feit.",
    "distractorExplanations": {
      "1": "Er staat 'uit onderzoek blijkt', niet 'ik vind dat'.",
      "2": "Het is duidelijk een feit door de onderzoeksgegevens.",
      "3": "Het is wel een feit."
    }
  },
  {
    "id": "TB-M8-002",
    "module": "Taalbegrip",
    "difficulty": 303,
    "question": "Lees de tekst:\n\n\"De opwarming van de aarde heeft grote gevolgen. Gletsjers smelten, de zeespiegel stijgt en extreme weersomstandigheden komen vaker voor. Wetenschappers zijn het erover eens dat menselijke activiteit de belangrijkste oorzaak is. Toch zijn er politici die dit ontkennen.\"\n\nWat is de beste samenvatting?",
    "options": [
      "Klimaatverandering heeft ernstige gevolgen en wordt veroorzaakt door mensen, maar niet iedereen accepteert dit",
      "Gletsjers smelten door de zon",
      "Politici en wetenschappers zijn het eens over het klimaat",
      "Extreme weersomstandigheden zijn normaal"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kritisch_lezen",
    "subSkill": "samenvatten",
    "familyId": "TB-SAMENVATTEN-KLIMAAT",
    "explanation": "De tekst beschrijft gevolgen, noemt de oorzaak (menselijke activiteit) en eindigt met een tegenstelling (politici ontkennen). De samenvatting vangt alle drie de elementen.",
    "distractorExplanations": {
      "1": "De zon wordt niet als oorzaak genoemd.",
      "2": "De tekst zegt juist dat sommige politici het NIET eens zijn.",
      "3": "De tekst zegt dat extreme weer VAKER voorkomt, niet dat het normaal is."
    }
  },
  {
    "id": "TB-M8-003",
    "module": "Taalbegrip",
    "difficulty": 303,
    "question": "Lees de tekst:\n\n\"Iedereen zou verplicht moeten sporten. Sport is gezond en het maakt je gelukkig. Bovendien leer je samenwerken.\"\n\nWelk woord maakt deze tekst een mening?",
    "options": [
      "'Moeten' (het is een verplichting die iemand voorstelt)",
      "'Sport' (het gaat over sport)",
      "'Bovendien' (het is een signaalwoord)",
      "'Gezond' (het gaat over gezondheid)"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kritisch_lezen",
    "subSkill": "feit_mening",
    "familyId": "TB-MENING-SPORT",
    "explanation": "'Zou moeten' drukt een wens of overtuiging uit. De schrijver vindt dat iedereen moet sporten — dat is een mening, geen feit.",
    "distractorExplanations": {
      "1": "Het onderwerp (sport) maakt het niet automatisch een mening.",
      "2": "Signaalwoorden maken een tekst niet tot een mening.",
      "3": "Dat sport gezond is, is een apart punt. 'Moeten' maakt het een mening."
    }
  },
  {
    "id": "TB-M8-004",
    "module": "Taalbegrip",
    "difficulty": 303,
    "question": "Lees de tekst:\n\n\"In de middeleeuwen geloofden mensen in draken. Reizigers vertelden verhalen over vuurspuwende monsters. Waarschijnlijk waren het krokodillen of grote hagedissen die ze hadden gezien.\"\n\nWat is de tekststructuur?",
    "options": [
      "Misverstand uit het verleden met een mogelijke verklaring",
      "Een sprookje over draken",
      "Een opsomming van dieren",
      "Een vergelijking tussen landen"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "tekststructuur",
    "familyId": "TB-STRUCTUUR-DRAKEN",
    "explanation": "De tekst beschrijft een oud geloof (draken) en geeft dan een mogelijke verklaring (krokodillen/hagedissen).",
    "distractorExplanations": {
      "1": "Het is geen sprookje maar een informatieve tekst.",
      "2": "Het is geen opsomming maar een verklaring.",
      "3": "Er worden geen landen vergeleken."
    }
  },
  {
    "id": "TB-M8-005",
    "module": "Taalbegrip",
    "difficulty": 303,
    "question": "Wat betekent het woord 'consequent' in de zin: 'Je moet consequent oefenen om beter te worden.'",
    "options": [
      "Regelmatig en volgens een vast patroon",
      "Heel hard",
      "Af en toe",
      "Met plezier"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-CONSEQUENT",
    "explanation": "'Consequent' betekent dat je steeds hetzelfde doet, regelmatig en volgens een vast plan.",
    "distractorExplanations": {
      "1": "Consequent gaat over regelmaat, niet over intensiteit.",
      "2": "'Af en toe' is juist het tegenovergestelde van consequent.",
      "3": "Plezier is iets anders dan regelmaat."
    }
  },
  {
    "id": "TB-M8-006",
    "module": "Taalbegrip",
    "difficulty": 303,
    "question": "Lees de tekst:\n\n\"Huiswerk afschaffen? Daar zijn we het niet mee eens. Huiswerk helpt leerlingen om de stof te herhalen. Zonder herhaling vergeet je 80% binnen een week.\"\n\nVanuit welk perspectief is deze tekst geschreven?",
    "options": [
      "Vanuit iemand die vóór huiswerk is",
      "Vanuit iemand die tegen huiswerk is",
      "Vanuit een neutrale positie",
      "Vanuit een leerling"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kritisch_lezen",
    "subSkill": "perspectief",
    "familyId": "TB-PERSPECTIEF-HUISWERK",
    "explanation": "'Daar zijn we het niet mee eens' laat zien dat de schrijver tegen afschaffing is, dus vóór huiswerk.",
    "distractorExplanations": {
      "1": "De schrijver is juist VOOR huiswerk (tegen afschaffing).",
      "2": "De tekst neemt duidelijk een standpunt in.",
      "3": "Er staat 'we', maar het perspectief is van iemand die vóór huiswerk is."
    }
  },
  {
    "id": "TB-M8-007",
    "module": "Taalbegrip",
    "difficulty": 303,
    "question": "Wat betekent het woord 'fictief' in de zin: 'Harry Potter is een fictief personage.'",
    "options": [
      "Verzonnen, niet echt bestaand",
      "Beroemd",
      "Grappig",
      "Historisch"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-FICTIEF",
    "explanation": "'Fictief' betekent verzonnen, niet echt. Het komt van 'fictie' (verzonnen verhalen).",
    "distractorExplanations": {
      "1": "Fictief gaat niet over bekendheid.",
      "2": "Fictief gaat niet over humor.",
      "3": "Historisch is juist het tegenovergestelde (echt gebeurd)."
    }
  },
  {
    "id": "TB-M8-008",
    "module": "Taalbegrip",
    "difficulty": 303,
    "question": "Lees de tekst:\n\n\"Nederland telt 17,5 miljoen inwoners. Het is een van de dichtstbevolkte landen ter wereld. Volgens sommige experts moet de bevolkingsgroei afgeremd worden. Anderen vinden juist dat groei goed is voor de economie.\"\n\nWelke zinnen bevatten feiten en welke meningen?",
    "options": [
      "Zin 1 en 2 zijn feiten, zin 3 en 4 zijn meningen",
      "Alle zinnen zijn feiten",
      "Alle zinnen zijn meningen",
      "Zin 1 is een feit, de rest zijn meningen"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kritisch_lezen",
    "subSkill": "feit_mening",
    "familyId": "TB-FEIT-MENING-BEVOLKING",
    "explanation": "Zin 1 (17,5 miljoen) en zin 2 (dichtstbevolkt) zijn controleerbare feiten. Zin 3 ('volgens experts... moet') en zin 4 ('anderen vinden') zijn meningen.",
    "distractorExplanations": {
      "1": "Zin 3 en 4 bevatten woorden als 'moet' en 'vinden', dat zijn meningen.",
      "2": "Zin 3 en 4 zijn duidelijk meningen.",
      "3": "Zin 2 is ook een feit (dichtstbevolkt is meetbaar)."
    }
  },
  {
    "id": "TB-M8-009",
    "module": "Taalbegrip",
    "difficulty": 303,
    "question": "Wat is een 'synoniem'?",
    "options": [
      "Een woord met dezelfde betekenis (bijv. auto en wagen)",
      "Een woord met de tegenovergestelde betekenis",
      "Een woord dat hetzelfde klinkt maar iets anders betekent",
      "Een woord uit een andere taal"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-SYNONIEM",
    "explanation": "Een synoniem is een woord met (bijna) dezelfde betekenis. Auto en wagen, blij en vrolijk, groot en fors.",
    "distractorExplanations": {
      "1": "Dat is een antoniem (tegengestelde).",
      "2": "Dat is een homofoon (bijv. weer en weer).",
      "3": "Dat is een leenwoord."
    }
  },
  {
    "id": "TB-M8-010",
    "module": "Taalbegrip",
    "difficulty": 303,
    "question": "Lees de tekst:\n\n\"Elke dag produceren we in Nederland 8 miljoen kilo afval. Een groot deel hiervan kan gerecycled worden. Toch belandt nog steeds veel afval op de vuilnisbelt. Als iedereen beter zou scheiden, zou er veel minder afval verbrand hoeven worden.\"\n\nWat is het doel van deze tekst?",
    "options": [
      "Mensen overtuigen om beter afval te scheiden",
      "Uitleggen hoe een vuilnisbelt werkt",
      "Laten zien dat Nederland veel afval produceert",
      "Informeren over recycling"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "doel_schrijver",
    "familyId": "TB-DOEL-AFVAL",
    "explanation": "De laatste zin ('als iedereen beter zou scheiden') is een oproep tot actie. De schrijver wil mensen overtuigen.",
    "distractorExplanations": {
      "1": "De tekst legt niet uit hoe een vuilnisbelt werkt.",
      "2": "Dat is een detail, niet het hoofddoel.",
      "3": "De tekst informeert, maar het doel is overtuigen (de oproep in de laatste zin)."
    }
  }
]